import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import './partners.css'
import ReferenceCard from './referenceCard'

import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import adgar from './Logos/adgar.png'
import uw from './Logos/uw.png'
import pw from './Logos/pw.png'
import mennica from './Logos/mennica.png'
import bgz from './Logos/BGZ.png'
import budimex from './Logos/budimex.png'
import cushman from './Logos/cushman.png'
import pzu from './Logos/pzu.png'
import elajko from './Logos/eljako.png'
import apleona from './Logos/apleona.png'
import knight from './Logos/knightfrank.png'
import warbud from './Logos/warbud.png'

var Translate = require('react-translate-component')

export default class PartnersContent extends React.Component {
  render () {
    const responsive = {
      superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 3
      },
      desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
      }
    }
    return (
      <Container className='content'>
        <h1 className='sectionTitle'>
          <Translate content='zaufali_nam' />
        </h1>
        <hr className='sectionTitleLine' />
        <p className='trusedUsText'>
          <Translate content='na_przestrzeni_lat' />
        </p>
        <Container id='partnerLogos'>
          <Row>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={adgar} alt='adgar' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={uw} alt='uw' />
            </Col>

            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={pw} alt='pw' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={mennica} alt='mennica' />
            </Col>

            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={bgz} alt='bgz' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={budimex} alt='budimex' />
            </Col>

            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={cushman} alt='cushman' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={pzu} alt='pzu' />
            </Col>

            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={elajko} alt='elajko' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={apleona} alt='apleona' />
            </Col>

            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={knight} alt='knight' />
            </Col>
            <Col md='3' sm='6' xs='6'>
              <img class='partner' src={warbud} alt='warbud' />
            </Col>
          </Row>
        </Container>
        <Carousel
          className='customCarousel'
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={false}
          //   autoPlay={this.props.deviceType !== 'mobile' ? true : false}
          //   autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition='transform 500ms ease-in-out'
          transitionDuration={500}
          containerClass='carousel-container'
          removeArrowOnDeviceType={['tablet', 'mobile']}
          deviceType={this.props.deviceType}
          dotListClass='custom-dot-list-style'
          itemClass='carousel-item-padding-40-px'
          arrows={true}
          renderDotsOutside={true}
        >
          <ReferenceCard
            className='mainCard'
            refText='“(...) firma MTD-Tomasz Dębek zaprezentowała najwyższą jakość wykonania powierzonego zadania przy zachowaniu krótkich terminów umownych. Jednocześnie doskonała koordynacja prac i talent organizacyjny kierownika robót pozwolił wykonać zakres umowny w sposób nieprzerwany i niezakłócający spokoju najemców naszego budynku. “'
            refName='Krystyna Wojciechowska'
            refProfession='glowny_inzynier'
          ></ReferenceCard>

          <ReferenceCard
            refText='“(...) Prace zostały wykonane profesjonalnie, w umówionym czasie, bez wyłączania poszczególnych pomieszczeń z eksploatacji. Nadzór Firmy wykazał się dużą wiedzą teoretyczną i praktyczną w trakcie realizacji umowy. Firma MTD-Tomasz Dębek, pracując u nas zasłużyła na miano solidnego i rzetelnego wykonawcy.”'
            refName='Leszek Kula'
            refProfession='czlonek_zarzadu'
          ></ReferenceCard>

          <ReferenceCard
            refText='“(...) firma MTD-Tomasz Dębek profesjonalnie wywiązała się ze swoich robót, w związku z czym możemy z pełną odpowiedzialnością polecić ją jako solidnego i sprawdzonego wykonawcę. “'
            refName='Jerzy Szawłowski'
            refProfession='prodziekan_wydzialu'
          ></ReferenceCard>

          <ReferenceCard
            refText='“(...) Firma MTD ze swoich zadań wywiązuje się solidnie i terminowo, przyczyniając się do utrzymywania wysokiej jakości świadczonych przez nas usług. Rekomenduję firmę MTD do konserwacji i wykonywania napraw ślusarki aluminiowej w budynkach klasy A.”'
            refName='Tomasz Pawłowski'
            refProfession='zarzadca_nieruchomosci'
          ></ReferenceCard>
        </Carousel>
      </Container>
    )
  }
}
